import React, { forwardRef, SVGProps } from 'react'
import { styled, keyframes } from '@hermes/web-components'

const rotate = keyframes`
  100% {
    transform: rotate(360deg);
  }
`

const RotatingSVG = styled('svg')`
  animation: ${rotate} 1.5s linear infinite;
`

const LoadingWheel = forwardRef<SVGSVGElement, SVGProps<SVGSVGElement>>((props, ref) => (
  <RotatingSVG
    ref={ref}
    xmlns="http://www.w3.org/2000/svg"
    width={23.811}
    height={23.812}
    viewBox="98.131 158.59 23.811 23.812"
    {...props}
  >
    <path
      fill="#AABDF3"
      d="M112.269 160.822a2.233 2.233 0 1 1-4.467 0 2.233 2.233 0 0 1 4.467 0Zm-2.233 17.115a2.232 2.232 0 1 0 0 4.463 2.232 2.232 0 0 0 0-4.463Zm9.674-9.674a2.233 2.233 0 1 0 0 4.467 2.233 2.233 0 0 0 0-4.467Zm-17.115 2.233a2.232 2.232 0 1 0-4.465-.001 2.232 2.232 0 0 0 4.465.001Zm.601 4.608a2.232 2.232 0 1 0 0 4.463 2.232 2.232 0 0 0 0-4.463Zm13.68 0a2.232 2.232 0 1 0 0 4.465 2.232 2.232 0 0 0 0-4.465Zm-13.68-13.681a2.232 2.232 0 1 0 0 4.465 2.232 2.232 0 0 0 0-4.465Z"
    />
  </RotatingSVG>
))

export default LoadingWheel
